module.exports = __webpack_public_path__ + "media/images/ic-pin-deliverer-db33e3a82f953a21976f9f676d9ea5cc.svg";